/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./RePassword.css";

class RePassword extends Component {
  render() {
    return (
      <div className="RePassword-view">
        <div className="RePassword-bg"></div>

        <div className="RePassword-main">
          <div className="RePassword-header">
            <a href="/newPassword">
              <div className="RePassword-back">
                <div className="RePassword-backBtn"></div>
                <div className="RePassword-backText">返回</div>
              </div>
            </a>

            <div className="RePassword-headingText">更改密碼</div>
          </div>

          <div className="RePassword-fieldbtn">
            <div className="RePassword-inputFieldContainer">
              <input
                type="password"
                className="RePassword-inputField"
                placeholder="重新輸入新的密碼"
              />
            </div>

            <a href="/confirmPassword">
              <div className="RePassword-nextBtn">確認</div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default RePassword;
